export default function wmFetch(url, params = {}) {
  window.fetchActive = window.fetchActive || 0;
  window.fetchActive++;
  const csrfTokenElement = document.querySelector('meta[name="csrf-token"]');
  let mergedParams = params;
  if (csrfTokenElement) {
    mergedParams = {
      ...params,
      headers: {
        'X-CSRF-Token': csrfTokenElement.content,
        ...params.headers,
      },
    };
  }

  return fetch(url, mergedParams)
    .then((res) => {
      window.fetchActive--;
      return res;
    })
    .catch((err) => {
      window.fetchActive--;
      throw err;
    });
}
